import Vue from 'vue'
import Router from 'vue-router'

import Calculator from '@/components/Calculator'
import Result from '@/components/Result'
import Details from '@/components/Details'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Calculator',
      component: Calculator
    },
    {
      path: '/details/',
      name: 'details',
      component: Details
    },
    {
      path: '/result/',
      name: 'result',
      component: Result
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    const rect = document.querySelector('#app').getBoundingClientRect()
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    return { x: 0, y: rect.y + scrollTop }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js